import { ApolloError } from '@apollo/client';

/**
 * Helper method to strip `GraphQL error:` string from errors returned from the apollo client. This
 * _may_ be solved by handling errors via the `@apollo/client/link/error` package.
 *
 * Relevant issues:
 * https://github.com/apollographql/apollo-client/issues/1812
 * https://github.com/apollographql/apollo-feature-requests/issues/46
 *
 * @param error Error message returned from an `ApolloClient` query/mutation.
 * @param fallbackMessage Returned if the error does not container the `GraphQL error:` string.
 */
export default function parseApolloError(
  error: Error,
  fallbackMessage?: string
) {
  let message: string = fallbackMessage || '';
  if (error && error.message) {
    if (error.message.indexOf('GraphQL error:') > -1) {
      message = error.message.substr('GraphQL error:'.length + 1);
    } else if (error.message.indexOf('Network error:') > -1) {
      message = `Network error, unable to complete request`;
    } else if (!fallbackMessage) {
      message = error.message;
    }
  }
  return message;
}

export function firstApolloGraphqlError(
  error: ApolloError,
  fallbackMessage: string
) {
  if (error.graphQLErrors.length > 0) return error.graphQLErrors[0].message;
  return fallbackMessage;
}

export function getApolloMutationErrorMessage(
  error: unknown,
  fallbackMessage: string
) {
  if (error instanceof ApolloError) {
    return firstApolloGraphqlError(
      error,
      parseApolloError(error, fallbackMessage) || fallbackMessage
    );
  }
  if (error instanceof Error) {
    return parseApolloError(error, fallbackMessage) || fallbackMessage;
  }
  return fallbackMessage;
}
